module.exports = __webpack_public_path__ + "static/media/nhietdo-doam.a27bb8d7.svg";